<template>
	<div class="app">
		<div class="app-content">
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import i18n from "@/lang/lang.js";
import AuthService from "@/services/Auth.service";
import EventBus from "@/eventbus.js";
import { useDayjs } from "@/plugins/dayjs/dayjs.plugin.js";

const { $setLocale } = useDayjs();

const user = ref(null);

onMounted(async () => {
	user.value = await AuthService.getUserInfo();
	const lang = user.value.language;
	i18n.locale.value = lang;
	EventBus.$emit("changedLanguage", lang);
	$setLocale(lang);

	// close chat widget if opened
	if (window.zE) {
		window.zE("messenger", "close");
	}
});
</script>

<style lang="scss" scoped>
.app {
	overflow: hidden;
	display: flex;
	height: 100vh;
	background-color: $background;

	.app-content {
		background-color: $background;
		flex: 1 1 0%;
		overflow-x: auto;
		overflow-y: scroll;

		&:focus {
			outline: 2px solid transparent;
			outline-offset: 2px;
		}
	}
}
</style>
